var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',[_c('h2',[_vm._v(" Create User ")])])],1),_c('user')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }